import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    IconButton,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import WarningRounded from "@material-ui/icons/WarningRounded";
import Config from "Config";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { send } from "../../SendRequest";
import { isNotEmpty, isObjectNotEmpty } from "../../Utils";
import AlertDialog from "../../component/AlertDialog/AlertDialog";
import Header from "../../component/Header/Header";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
const useStyles = makeStyles({
    root: {
        width: "85%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    container: {
        maxHeight: 250,
    },
    tableRow: {
        height: 60,
    },
    tableCell: {
        height: 10,
    },
    reminderBox: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 100px 0px 20px",
    },
    reminderBoxMobile: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 20px 0px 20px",
    },
});

function EditOrgEdb() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    const dispatch = useDispatch();
    const [loginData, setLoginData] = useState(null);
    const [orgList, setOrgList] = useState({});
    const [selectedOrg, setSelectedOrg] = useState("");
    const [refresh, setRefresh] = useState({});
    const [isCurrAdmin, setIsCurrAdmin] = useState(false);
    const [emailInUse, setEmailInUse] = useState(false);
    const [infoInUse, setInfoInUse] = useState(false);
    const [deleteOrgDialog, setDeleteOrgDialog] = useState(false);
    const [deleteOrg, setDeleteOrg] = useState({});
    const handleConfirm = () => {
        setIsCurrAdmin(false);
        setEmailInUse(false);
        setInfoInUse(false);
    };

    useEffect(() => {
        const option = {
            url: `${Config.CONTENT_PATH}/organizations/getOrganization`,
        };
        dispatch(send("GET_ORGANIZATION", option))
            .then((response) => response.json())
            .then((result) => {
                console.log("result:" + JSON.stringify(result));
                setOrgList(result);
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }, [refresh]);

    console.log("orgList:" + JSON.stringify(orgList));
    function addAdmin(orgName, adminEmail) {
        const newAdmin = {
            name: orgName,
            admin: adminEmail,
        };
        const option = {
            url: `${Config.CONTENT_PATH}/organizations/addAdmin`,
            method: "POST",
            body: JSON.stringify(newAdmin),
        };
        const targetObj = orgList.find((element) => element.name === orgName);
        if (targetObj.admin.every((item) => item.email != adminEmail)) {
            dispatch(send("ADD_ORGANIZATION_ADMIN", option))
                .then((response) => response.json())
                .then((result) => {
                    console.log("result: ", result);
                    setOrgList(result);
                    setAdminEmail("");
                })
                .catch((error) => {
                    console.log("fetch error: ", error);
                    setEmailInUse(true);
                });
        } else {
            setIsCurrAdmin(true);
        }
    }

    function addNewOrgItem(orgName, adminEmail) {
        const newOrg = {
            name: orgName?.replace(/^\s+|\s+$/g, ""),
            admin: adminEmail,
        };
        const option = {
            url: `${Config.CONTENT_PATH}/organizations/addOrganization`,
            method: "POST",
            body: JSON.stringify(newOrg),
        };
        dispatch(send("ADD_ORGANIZATION", option))
            .then((response) => response.json())
            .then((result) => {
                console.log("result: ", result);
                setOrgList(result);
                setOrg("");
                setNewOrgAdmin("");
            })
            .catch((error) => {
                console.log("fetch error: ", error);
                setInfoInUse(true);
            });
    }

    function deleteOrgItem(orgName) {
        const option = {
            url: `${Config.CONTENT_PATH}/organizations/removeOrganization/${orgName}`,
            method: "PUT",
        };
        dispatch(send("REMOVE_ORGANIZATION", option))
            .then((response) => response.json())
            .then((result) => {
                console.log("result: ", result);
                setDeleteOrg({});
                setDeleteOrgDialog(false);
                setOrgList(result);
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }

    function deleteAdmin(adminEmail, selectedOrg) {
        const oldAdmin = {
            name: selectedOrg,
            admin: adminEmail,
        };
        const option = {
            url: `${Config.CONTENT_PATH}/organizations/removeAdmin`,
            method: "PUT",
            body: JSON.stringify(oldAdmin),
        };
        dispatch(send("REMOVE_ORGANIZATION_ADMIN", option))
            .then((response) => response.json())
            .then((result) => {
                console.log("result: ", result);
                setOrgList(result);
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }

    const [isSavedOpen, setIsSavedOpen] = useState(false);
    const handleSavedClose = () => {
        setIsSavedOpen(false);
    };
    function SavedDialog(open) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={open}>
                    <DialogTitle
                        id="simple-dialog-title"
                        style={{ textAlign: "center" }}
                    >
                        {t("common.portal.savedSuccessfully")}
                    </DialogTitle>
                    <DialogContent style={{ textAlign: "center" }}>
                        {t("common.portal.changesSaved")}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={handleSavedClose}
                            color="success"
                        >
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    useEffect(() => {
        fetch("/eformss/organizations/getSSLOOrg")
            .then((res) => {
                //this localhost saved all the data from Data.json!!
                return res.json();
            })
            .then((data) => {
                setLoginData(data);
                return data;
            });
    }, []);

    //let result;
    let arr = [];
    if (loginData != null) {
        //<======fetch data take time,so this condititon is nessasary!
        for (let i = 0; i < loginData.length; i++) {
            arr.push(loginData[i]); //<=======================================save all the email into the array from the fetched data!!
        }
        console.log(arr);
    }

    const getDifference = (array1, array2) => {
        return array1.filter((object1) => {
            return !array2.some((object2) => {
                return object1.email != object2.email;
            });
        });
    };

    const checkEmail = (name) => {
        /*name.length===0?name.push({email:0}):null;//<===============need to push the <email:0> key for sa kto the array otherwise it cannot read. 
        console.log(name);
        result = arr.filter((em) => em === name[0].email);*/
        if (name.length === 0) return true;

        name.length === 0 ? name.push({ email: 0 }) : null;
        //result = arr.filter((em) => em === name[0].email);
        //const result = arr.filter(({email1}) => !name.some(({email2}) => email2 === email1));
        const results = [
            ...getDifference(arr, name),
            ...getDifference(name, arr),
        ];
        return results.length > 0;
        /*if (result.length > 0) {
            return true;
        }else if(name[0].email===0){
            return true;
        }
         else {
            return false;
        }*/
    };

    // const onSubmit = () => {
    //     const option = {
    //         url: `${Config.CONTENT_PATH}/organizations/updateOrganization`,
    //         method: "POST",
    //         body: JSON.stringify(orgList),
    //     };
    //     dispatch(send("UPDATE_ORGANIZATION", option))
    //         .then((response) => response.json())
    //         .then((result) => {
    //             console.log("result: ", result);
    //             setOrgList(result);
    //             setIsSavedOpen(true);
    //         })
    //         .catch((error) => {
    //             console.log("fetch error: ", error);
    //             alert("This organization or user email is already in use.");
    //             setRefresh({});
    //         });
    //     setRefresh({});
    //     console.log("submitted:" + JSON.stringify(orgList));
    // };

    const [adminEmail, setAdminEmail] = useState("");
    const [org, setOrg] = useState("");
    const [newOrgAdmin, setNewOrgAdmin] = useState("");
    const [isFieldEmpty, setIsFieldEmpty] = useState(false);
    const [isEmailInvalid, setIsEmailInvalid] = useState(false);
    const [isAdminInvalid, setIsAdmindInvalid] = useState(false);

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.sideNavList.editOrgEdb")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <Box className="main">
                    {/* Part1:Organizations */}
                    <Typography variant="h6" component="h1">
                        <br />
                        {t("common.portal.editCurrentOrg")}
                    </Typography>
                    <Paper></Paper>
                    <TableContainer component={Paper}>
                        <Table
                            stickyHeader
                            size="small"
                            aria-label="a dense table"
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        align="center"
                                        style={{
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {t("common.portal.name")}
                                    </TableCell>

                                    <TableCell component="td"></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {isObjectNotEmpty(orgList) &&
                                orgList != undefined
                                    ? orgList.map((item) => (
                                          <React.Fragment key={item.name}>
                                              <TableRow
                                                  className={classes.tableRow}
                                              >
                                                  <TableCell align="center">
                                                      {item.name}
                                                  </TableCell>
                                                  <TableCell
                                                      style={{
                                                          width: "10px",
                                                      }}
                                                  >
                                                      {item != null &&
                                                          !checkEmail(
                                                              item.admin
                                                          ) && (
                                                              <IconButton
                                                                  onClick={() => {
                                                                      setDeleteOrg(
                                                                          item
                                                                      );
                                                                      setDeleteOrgDialog(
                                                                          true
                                                                      );
                                                                  }}
                                                                  color="primary"
                                                                  aria-label="delete"
                                                              >
                                                                  <RemoveCircleIcon />
                                                              </IconButton>
                                                          )}
                                                  </TableCell>
                                              </TableRow>
                                          </React.Fragment>
                                      ))
                                    : null}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <br />
                    <Paper>
                        <CustomTextField
                            label={t("common.portal.nameOfOrg")}
                            id="nameOfOrg"
                            placeholder={t("common.portal.inputNameOfOrg")}
                            value={org}
                            onChange={(e) => setOrg(e.target.value)}
                            style={{ width: matches ? "90%" : "85%" }}
                        ></CustomTextField>
                        <CustomTextField
                            label={t("common.portal.emailOfAdmin")}
                            id="emailOfAdmin"
                            placeholder={t("common.portal.inputEmailOfAdmin")}
                            value={newOrgAdmin}
                            onChange={(e) => setNewOrgAdmin(e.target.value)}
                            style={{ width: matches ? "90%" : "85%" }}
                        ></CustomTextField>
                        <IconButton
                            onClick={() => {
                                if (org === "" || newOrgAdmin === "") {
                                    setIsFieldEmpty(true);
                                } else if (!newOrgAdmin.includes("@")) {
                                    setIsEmailInvalid(true);
                                } else {
                                    addNewOrgItem(org, newOrgAdmin);
                                    setIsFieldEmpty(false);
                                    setIsEmailInvalid(false);
                                }
                            }}
                            style={{ marginTop: "-2rem", marginLeft: "0.5rem" }}
                            color="primary"
                            aria-label="emailOfAdmin"
                        >
                            <AddCircleIcon />
                        </IconButton>
                        {isEmailInvalid ? (
                            <Box name="errorMsg" display="flex" mt={3}>
                                <Box>
                                    <WarningRounded color="error" />
                                </Box>
                                <Box p={1}>
                                    <Typography
                                        component={"span"}
                                        color="error"
                                    >
                                        {t("common.portal.inputValidEmail")}
                                    </Typography>
                                </Box>
                            </Box>
                        ) : null}
                        {isFieldEmpty ? (
                            <Box name="errorMsg" display="flex" mt={3}>
                                <Box>
                                    <WarningRounded color="error" />
                                </Box>
                                <Box p={1}>
                                    <Typography
                                        component={"span"}
                                        color="error"
                                    >
                                        {t(
                                            "common.portal.eitherFieldsCannotBeEmpty"
                                        )}
                                    </Typography>
                                </Box>
                            </Box>
                        ) : null}
                    </Paper>
                    <br />
                    {/* Part2: Admin of each organizations */}
                    <Typography variant="h6" component="h1">
                        {t("common.portal.assignAdmin")}
                    </Typography>
                    <Paper>
                        <FormControl id="admin">
                            <Select
                                label="admin"
                                inputProps={{
                                    "aria-labelledby": "admin",
                                }}
                                value={selectedOrg}
                                style={{ textAlign: "end" }}
                                onChange={(e) => setSelectedOrg(e.target.value)}
                            >
                                {isObjectNotEmpty(orgList) &&
                                    orgList.map(
                                        (element) =>
                                            element.name !==
                                                "System Administrator" && (
                                                <MenuItem
                                                    value={element.name}
                                                    key={element.name}
                                                >
                                                    {element.name}
                                                </MenuItem>
                                            )
                                    )}
                            </Select>
                        </FormControl>

                        <br />
                        <TableContainer component={Paper}>
                            <Table
                                stickyHeader
                                size="small"
                                aria-label="a dense table"
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {t("common.portal.name")}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {t("common.portal.email")}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {t("common.portal.post")}
                                        </TableCell>
                                        <TableCell component="td"></TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {isObjectNotEmpty(orgList) &&
                                        orgList
                                            .filter(
                                                (obj) =>
                                                    obj.name === selectedOrg
                                            )[0]
                                            ?.admin.map((item) => (
                                                <React.Fragment
                                                    key={item.email}
                                                >
                                                    <TableRow>
                                                        <TableCell align="center">
                                                            {item.name}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <a
                                                                href={`mailto:${item.email}`}
                                                                style={{
                                                                    color: "black",
                                                                }}
                                                            >
                                                                {item.email}
                                                            </a>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {item.post}
                                                        </TableCell>
                                                        <TableCell
                                                            style={{
                                                                width: "10px",
                                                            }}
                                                        >
                                                            <IconButton
                                                                onClick={() =>
                                                                    deleteAdmin(
                                                                        item.email,
                                                                        selectedOrg
                                                                    )
                                                                }
                                                                color="primary"
                                                                aria-label="delete"
                                                            >
                                                                <RemoveCircleIcon />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                </React.Fragment>
                                            ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <br />
                        <CustomTextField
                            label={
                                <>
                                    <Typography component="span">
                                        {t("common.portal.typeEmailStart")}
                                    </Typography>
                                    <AddCircleIcon
                                        style={{
                                            margin: "0 5px",
                                            color: "#A74128",
                                        }}
                                    />
                                    <Typography component="span">
                                        {t("common.portal.typeEmailEnd")}
                                    </Typography>
                                </>
                            }
                            id="typeEmail"
                            placeholder={t("common.portal.inputEmail")}
                            value={adminEmail}
                            onChange={(e) => setAdminEmail(e.target.value)}
                            style={{ width: matches ? "90%" : "85%" }}
                            displayColon={false}
                        ></CustomTextField>
                        <IconButton
                            onClick={() => {
                                if (
                                    adminEmail != "" &&
                                    adminEmail.includes("@")
                                ) {
                                    addAdmin(selectedOrg, adminEmail);
                                    setIsAdmindInvalid(false);
                                } else {
                                    setIsAdmindInvalid(true);
                                }
                            }}
                            style={{ marginTop: "0.8rem" }}
                            color="primary"
                            aria-label="adminEmail"
                        >
                            <AddCircleIcon />
                        </IconButton>
                        {isAdminInvalid ? (
                            <Box name="errorMsg" display="flex" mt={3}>
                                <Box>
                                    <WarningRounded color="error" />
                                </Box>
                                <Box p={1}>
                                    <Typography
                                        component={"span"}
                                        color="error"
                                    >
                                        {t("common.portal.inputValidEmail")}
                                    </Typography>
                                </Box>
                            </Box>
                        ) : null}
                    </Paper>
                    <br />
                    {/* <FormBox>
                        <Box display="flex" justifyContent="flex-end">
                            <Button
                                variant="contained"
                                color="primary"
                                // type="submit"
                                onClick={onSubmit}
                            >
                                SAVE
                            </Button>
                        </Box>
                    </FormBox> */}
                </Box>
            </Box>
            {isSavedOpen ? SavedDialog(isSavedOpen) : null}
            <AlertDialog
                formOpen={isCurrAdmin}
                content={t("common.portal.alreadyIncludedOrg")}
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <AlertDialog
                formOpen={emailInUse}
                content={
                    <React.Fragment>
                        <Typography>{t("common.portal.emailInUse")}</Typography>
                        <Typography>{t("common.portal.checkAgain")}</Typography>
                    </React.Fragment>
                }
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <AlertDialog
                formOpen={infoInUse}
                content={
                    <React.Fragment>
                        <Typography>
                            <Typography>
                                {t("common.portal.orgNameOrEmailInUse")}
                            </Typography>
                        </Typography>
                        <Typography>{t("common.portal.checkAgain")}</Typography>
                    </React.Fragment>
                }
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <Dialog
                onClose={() => {
                    setDeleteOrg({});
                    setDeleteOrgDialog(false);
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                open={deleteOrgDialog}
                fullWidth={true}
            >
                <DialogContent id="alert-dialog-title">
                    <DialogContentText id="alert-dialog-description">
                        <React.Fragment>
                            <Typography>
                                <Typography>
                                    {t("common.portal.deleteOrg")}
                                </Typography>
                            </Typography>
                        </React.Fragment>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            if (isNotEmpty(deleteOrg?.name)) {
                                deleteOrgItem(deleteOrg?.name);
                            }
                        }}
                    >
                        {t("common.reload.popup.confirm")}
                    </Button>
                    <Button
                        onClick={() => {
                            setDeleteOrg({});
                            setDeleteOrgDialog(false);
                        }}
                    >
                        {t("common.save.popup.cancel")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}
export default EditOrgEdb;
